import {isRailway} from '../../../../../lib/travels/operation-type'
import Mixin from '../_transactions_mixin'

import template from './_transaction.pug'

const QR_MEDIA_TYPE = 2
const TNE_MEDIA_TYPE = 4

const TYPE_CHARGE = 5
const TYPE_VALIDATION = 8

const VALIDATION_TYPE_VALIDATION = 1
const VALIDATION_TYPE_HOP_ON_HOP_OFF = 2
const VALIDATION_TYPE_PENALIZATION = 3

// @vue/component
export default {
  template: template(),
  mixins: [Mixin],
  props: {
    transaction: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true
    },
    accountBalance: {
      type: Number,
      required: true
    },
    transactionsAmounts: {
      type: Array,
      required: true
    }
  },
  computed: {
    // Comprueba si la transacción es una recarga o no
    isCharge() {
      return this.transaction.type === TYPE_CHARGE
    },

    isValidation() {
      return this.transaction.type === TYPE_VALIDATION
    },

    isValidationSimple() {
      return this.isValidation && this.transaction.validation_type === VALIDATION_TYPE_VALIDATION
    },

    isVoidedValidation() {
      return this.isValidation && this.transaction.voided_validation
    },

    isHopOnHopOff() {
      return this.isValidation &&
        this.transaction.validation_type === VALIDATION_TYPE_HOP_ON_HOP_OFF
    },

    hasDestination() {
      return this.transaction.has_destination
    },

    isPenalization() {
      return this.isValidation && this.transaction.validation_type === VALIDATION_TYPE_PENALIZATION
    },

    // Si tiene información adicional
    hasExtraInfo() {
      return this.travelAmount !== undefined
    },

    // Saldo bonificado al usuario
    bonusAmount() {
      const transaction = this.transaction
      if (this.isCharge) {
        return (transaction.recharge_amount || 0) - (transaction.paid_amount || 0)
      }
      return undefined
    },

    // Saldo que debería tener el medio en esta transacción
    assumedBalance() {
      const accumulatedAmounts = this.transactionsAmounts
        .slice(0, this.index)
        .reduce((a, b) => a + b, 0)

      return this.accountBalance + accumulatedAmounts
    },

    // Coste del viaje
    travelAmount() {
      if (this.isValidation) {
        return this.transaction.amount || 0
      }
      return undefined
    },

    // Ruta de la transacción
    route() {
      return this.transaction.route || {}
    },

    // Paradero de la transacción
    stop() {
      return this.transaction.stop || {}
    },

    // Nombre del tipo de medio
    mediaTypeName() {
      if (!this.transaction.media_type) { return '' }

      return this.$t(`balance.transaction.mediaTypes.${this.transaction.media_type}`)
    },

    /** Prepared for the case of alias being required instead of external code */
    mediaType () {
      return this.$store.getters['user/paymentMethods']
        .find(i => this.transaction.media_code === i.external_code) || {}
    },

    transactionAmount(){
      return this.isCharge ? this.transaction.paid_amount : this.transaction.amount
    },

    // Nombre del tipo de transacción
    typeName() {
      if (this.isCharge) { return this.$t('balance.transaction.type.recharge') }
      if (this.isValidation) { return this.validationTypeName }
      return ''
    },

    validationTypeName() {
      const names = {}
      names[VALIDATION_TYPE_VALIDATION] = this.$t('balance.transaction.type.validation')
      names[VALIDATION_TYPE_HOP_ON_HOP_OFF] = this.$t('balance.transaction.type.hopOnHopOff')
      names[VALIDATION_TYPE_PENALIZATION] = this.$t('balance.transaction.type.penalization')

      return names[this.transaction.validation_type]
    },

    // Icono del tipo de la transacción
    typeIcon() {
      if (this.isCharge) { return 'ns-icon-coins text-primary' }
      if (this.isValidation) { return this.validationTypeIcon }
      return ''
    },

    validationTypeIcon() {
      const icons = {}
      icons[VALIDATION_TYPE_HOP_ON_HOP_OFF] = 'double-icon'
      icons[VALIDATION_TYPE_PENALIZATION] = 'double-icon--red-arrow'
      icons[VALIDATION_TYPE_VALIDATION] = 'ns-icon-ticket text-gray2'

      return icons[this.transaction.validation_type]
    },

    mediaTypeIcon() {
      const icons = {}
      icons[QR_MEDIA_TYPE] = 'ns-icon-qr'
      icons[TNE_MEDIA_TYPE] = 'ns-icon-tne'

      return icons[this.transaction.media_type]
    },

    // Color del tipo de la transacción
    typeColor() {
      if (this.isCharge) { return 'text-primary' }
      return 'text-gray2'
    },

    // Color de la ruta de la transacción
    routeColor() {
      return `background-color:${this.route.color};`
    },

    isRailway() {
      return isRailway(this.transaction.tipo_operacion)
    }
  }
}
